"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBlockQuoteToken = exports.BlockQuoteConfig = exports.getBlockquoteMarkerTheme = void 0;
var Blockquote_css_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Text/Blockquote.css");
var classnames_1 = __importDefault(require("classnames"));
var textStyles_1 = require("../Traits/Styleable/textStyles");
var colord_1 = require("colord");
var dynamic_1 = require("@vanilla-extract/dynamic");
var getBlockquoteMarkerTheme = function (color) {
    return (0, colord_1.colord)(color).luminance() > 0.5 ? "dark" : "light";
};
exports.getBlockquoteMarkerTheme = getBlockquoteMarkerTheme;
exports.BlockQuoteConfig = {
    type: "blockQuote",
    tokenType: {},
    publicRender: function (_a) {
        var _b;
        var attributes = _a.attributes, computeForegroundColor = _a.computeForegroundColor, innerHtml = _a.innerHtml, style = _a.style;
        if (innerHtml === "" || /^<span[^>]*><\/span>$/.test(innerHtml)) {
            innerHtml = "<br />";
        }
        var barColor = computeForegroundColor ? computeForegroundColor(style.barColor.abs) : style.barColor.abs;
        var styleString = (0, textStyles_1.generateStyleStringFromObject)(__assign(__assign(__assign({}, attributes.style), (barColor && (0, dynamic_1.assignInlineVars)((_b = {}, _b[Blockquote_css_1.vars.barColor] = barColor, _b)))), (0, textStyles_1.maybeAssignComputedForegroundColor)({
            computeForegroundColor: computeForegroundColor,
            foregroundColorVar: Blockquote_css_1.vars.color,
            foregroundStyle: { color: style.color },
        })));
        return "<blockquote class=\"".concat(attributes.className, " ").concat((0, Blockquote_css_1.blockquoteWidget)({ showIcon: style.displayQuoteIcon, markerTheme: (0, exports.getBlockquoteMarkerTheme)(barColor) }), "\" style=\"").concat(styleString, "\">").concat(innerHtml, "</blockquote>");
    },
    traits: {
        spacingShim: {
            className: (0, classnames_1.default)("blockquote-widget__spacing-shim", Blockquote_css_1.blockquoteSpacingShim),
        },
        styleable: {
            styleKey: "blockQuote",
            properties: [
                {
                    type: "color",
                    label: "Text color",
                    path: "color",
                    defaultValue: "DERIVED_FROM_PARAGRAPH_HACK",
                    variable: Blockquote_css_1.vars.color,
                },
                {
                    type: "fontSize",
                    label: "Text size",
                    max: 100,
                    min: 14,
                    defaultValue: { abs: 20, themeRef: null },
                    variable: Blockquote_css_1.vars.fontSize,
                    path: "size",
                },
                {
                    type: "color",
                    label: "Bar color",
                    path: "barColor",
                    variable: Blockquote_css_1.vars.barColor,
                    defaultValue: {
                        themeIndex: 0,
                    },
                    presetColors: { type: "filteredThemeColors" },
                },
                {
                    type: "boolean",
                    label: "Display quote icon",
                    defaultValue: true,
                    path: "displayQuoteIcon"
                }
            ]
        }
    },
};
var createBlockQuoteToken = function () { return ({
    type: "block",
    subType: "blockQuote",
}); };
exports.createBlockQuoteToken = createBlockQuoteToken;
